import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const dynamicEnvironmentPlugin = createPlugin({
  id: 'dynamic-environment',
  routes: {
    root: rootRouteRef,
  },
});

export const DynamicEnvironmentPage = dynamicEnvironmentPlugin.provide(
  createRoutableExtension({
    name: 'DynamicEnvironmentPage',
    component: () => import('./components/modules').then(m => m.ManagementEnvironmentModule),
    mountPoint: rootRouteRef,
  }),
);
